import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import ReactMarkdown from 'react-markdown';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const TermsAndConditions = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axios.get(`${API}/site-config`);
        setContent(response.data.terms_and_conditions || '');
      } catch (error) {
        console.error('Failed to fetch terms:', error);
        setContent('# Terms and Conditions\n\nUnable to load terms and conditions. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    fetchTerms();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl font-playfair">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-primary text-white py-4 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="text-xl font-playfair font-bold">FB Attorneys Academy</h1>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="prose prose-lg max-w-none">
          <ReactMarkdown
            components={{
              h1: ({ children }) => (
                <h1 className="text-3xl font-playfair font-bold text-primary mb-6">{children}</h1>
              ),
              h2: ({ children }) => (
                <h2 className="text-2xl font-playfair font-bold text-primary mt-8 mb-4">{children}</h2>
              ),
              h3: ({ children }) => (
                <h3 className="text-xl font-bold text-primary mt-6 mb-3">{children}</h3>
              ),
              p: ({ children }) => (
                <p className="text-gray-700 mb-4 leading-relaxed">{children}</p>
              ),
              ul: ({ children }) => (
                <ul className="list-disc ml-6 mb-4 text-gray-700 space-y-2">{children}</ul>
              ),
              li: ({ children }) => (
                <li className="text-gray-700">{children}</li>
              ),
              hr: () => (
                <hr className="my-8 border-gray-300" />
              ),
            }}
          >
            {content}
          </ReactMarkdown>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-accent text-white py-8">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-gray-300">&copy; {new Date().getFullYear()} FB Attorneys Academy. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default TermsAndConditions;
